import React, { useState } from 'react';
import { 
  FaChevronRight, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaPaperPlane,
  FaUser,
  FaMobileAlt,
  FaCommentDots,
  FaClock,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp
} from 'react-icons/fa';
import '../style.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        message: ''
      });
    }, 3000);
  };

  const contactInfo = [
    {
      icon: <FaPhoneAlt />,
      title: "Emergency & Appointment",
      details: ["+91 80903 11155", "+91 80903 11155"],
      color: "#4f46e5"
    },
    {
      icon: <FaEnvelope />,
      title: "Email Address",
      details: ["sandy27u@gmail.com", "sweta27u@gmail.com"],
      color: "#10b981"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Location",
      details: [
        "8X5M+G9H, Sigra - Mahmoorganj Rd",
        "behind Hotel Padmini, Maa Rajeshwari Nagar",
        "Sigra, Varanasi, Uttar Pradesh 221010"
      ],
      color: "#ec4899"
    },
    {
      icon: <FaClock />,
      title: "Working Hours",
      details: [
        "Monday - Saturday: 9:00 AM - 8:00 PM",
        "Sunday: 10:00 AM - 6:00 PM",
        "Emergency: 24/7 Available"
      ],
      color: "#f59e0b"
    }
  ];

  const socialLinks = [
    { icon: <FaFacebookF />, name: "Facebook", color: "#1877F2", url: "#" },
    { icon: <FaTwitter />, name: "Twitter", color: "#1DA1F2", url: "#" },
    { icon: <FaInstagram />, name: "Instagram", color: "#E4405F", url: "#" },
    { icon: <FaLinkedinIn />, name: "LinkedIn", color: "#0077B5", url: "#" },
    { icon: <FaWhatsapp />, name: "WhatsApp", color: "#25D366", url: "#" }
  ];

  return (
    <div className="compact-contact">
      {/* Hero Header */}
      <div className="cc-hero">
        <div className="cc-container">
          <div className="cc-hero-content">
            <div className="cc-breadcrumb">
              <span>Home</span>
              <FaChevronRight />
              <span className="cc-divider">–</span>
              <span>Medical</span>
              <FaChevronRight />
              <span className="cc-divider">–</span>
              <span className="cc-current">Contact Us</span>
            </div>
            <h1 className="cc-title">Contact Us</h1>
            <p className="cc-subtitle">
              Reach out for appointments, consultations, or any healthcare inquiries.
            </p>
          </div>
        </div>
      </div>

      {/* Contact Info Cards - Grid Layout */}
      <div className="cc-container">
        <div className="cc-info-grid">
          {contactInfo.map((item, index) => (
            <div key={index} className="cc-info-card">
              <div className="cc-card-header">
                <div className="cc-card-icon" style={{ color: item.color }}>
                  {item.icon}
                </div>
                <h3 className="cc-card-title">{item.title}</h3>
              </div>
              <div className="cc-card-content">
                {item.details.map((detail, idx) => (
                  <p key={idx} className="cc-card-detail">{detail}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content - Form and Map */}
      <div className="cc-container">
        <div className="cc-main-layout">
          {/* Contact Form */}
          <div className="cc-form-section">
            <div className="cc-form-header">
              <h2 className="cc-form-title">
                <FaCommentDots /> Send Message
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="cc-contact-form">
              {submitted && (
                <div className="cc-success">
                  <FaPaperPlane /> Message sent successfully!
                </div>
              )}

              <div className="cc-form-grid">
                <div className="cc-form-group">
                  <label className="cc-form-label">
                    <FaUser /> First Name
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First name"
                    className="cc-input"
                    required
                  />
                </div>
                
                <div className="cc-form-group">
                  <label className="cc-form-label">
                    <FaUser /> Last Name
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last name"
                    className="cc-input"
                    required
                  />
                </div>
              </div>

              <div className="cc-form-grid">
                <div className="cc-form-group">
                  <label className="cc-form-label">
                    <FaMobileAlt /> Phone
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone number"
                    className="cc-input"
                    required
                  />
                </div>
                
                <div className="cc-form-group">
                  <label className="cc-form-label">
                    <FaEnvelope /> Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email address"
                    className="cc-input"
                    required
                  />
                </div>
              </div>

              <div className="cc-form-group">
                <label className="cc-form-label">
                  <FaCommentDots /> Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your message..."
                  className="cc-textarea"
                  rows="4"
                  required
                />
              </div>

              <button type="submit" className="cc-submit">
                <FaPaperPlane /> Send Message
              </button>
            </form>
          </div>

          {/* Map and Social */}
          <div className="cc-side-section">
            {/* Map */}
            <div className="cc-map-card">
              <div className="cc-map-header">
                <h3 className="cc-map-title">
                  <FaMapMarkerAlt /> Our Location
                </h3>
              </div>
              <div className="cc-map-content">
                <p className="cc-address">
                  8X5M+G9H, Sigra - Mahmoorganj Rd, behind Hotel Padmini, 
                  Maa Rajeshwari Nagar, Sigra, Varanasi, Uttar Pradesh 221010
                </p>
                <button className="cc-directions">
                  Get Directions
                </button>
              </div>
            </div>

            {/* Social Links */}
            <div className="cc-social-card">
              <div className="cc-social-header">
                <h3 className="cc-social-title">Connect With Us</h3>
              </div>
              <div className="cc-social-grid">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    className="cc-social-link"
                    style={{ backgroundColor: social.color }}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div className="cc-actions-card">
              <div className="cc-actions-header">
                <h3 className="cc-actions-title">Quick Actions</h3>
              </div>
              <div className="cc-actions-grid">
                <button className="cc-action cc-emergency">
                  <FaPhoneAlt /> Emergency
                </button>
                <button className="cc-action cc-whatsapp">
                  <FaWhatsapp /> WhatsApp
                </button>
                <button className="cc-action cc-appointment">
                  <FaClock /> Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="cc-faq-section">
        <div className="cc-container">
          <div className="cc-faq-header">
            <h2 className="cc-faq-title">Frequently Asked Questions</h2>
          </div>
          <div className="cc-faq-grid">
            <div className="cc-faq-item">
              <h4 className="cc-faq-q">What are your working hours?</h4>
              <p className="cc-faq-a">Monday-Saturday: 9AM-8PM, Sunday: 10AM-6PM, Emergency: 24/7</p>
            </div>
            <div className="cc-faq-item">
              <h4 className="cc-faq-q">How to book appointment?</h4>
              <p className="cc-faq-a">Call, use form, or WhatsApp. Online booking coming soon.</p>
            </div>
            <div className="cc-faq-item">
              <h4 className="cc-faq-q">Emergency services?</h4>
              <p className="cc-faq-a">24/7 emergency services available.</p>
            </div>
            <div className="cc-faq-item">
              <h4 className="cc-faq-q">Insurance accepted?</h4>
              <p className="cc-faq-a">Most major insurance providers accepted.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;